export enum LayoutsEnum {
  DEFAULT = "default",
  BLANK = "blank",
}
